
import { Options, Vue } from 'vue-class-component';
import apiConfig from '@/config/api';
import { Location } from "@/data/location";

//import {} from '@types/google.maps';
//import * as google from '@types/google.maps';

type Region = {
    id: number,
    name: string,
    lat: number,
    lng: number,
    manager: any,
};

@Options({
    props: {
        google: {
            type: Object,
            required: true,
        },
        map: {
            type: Object,
            required: true,
        },
        /*region: {
            type: Object,
            required: true,
        },*/
        location: {
            type: Object,
            required: true,
        },
    },
    components: {

    },
})
export default class LocationMarker extends Vue {
    google!: any //google
    map!: any //google.maps.Map
    // region!: Region
    location!: Location

    marker: any = null

    infoWindow: any = null

    iconUrl = apiConfig.frontendAssetsUrl + '/img/markers/dark-green.png'

    get infoWindowContent(): string {
        return 'Park<br><b style="font-weight:700">' + this.location.name + '</b>';
    }

    handleClick() {
        this.$emit('click');
    }

    mounted() {
        this.infoWindow = new this.google.maps.InfoWindow({
            content: this.infoWindowContent,
        });

        this.marker = new this.google.maps.Marker({
            position: { lat: this.location.lat, lng: this.location.lng },
            //marker: this.marker,
            map: this.map,
            icon: {
                url: this.iconUrl,
                scaledSize: new this.google.maps.Size(24, 35)
            },
            title: 'Park: ' + this.location.name,
            //animation: this.google.maps.Animation.DROP,
            clickable: true,
            optimized: true,
        });

        this.marker.addListener('click', this.handleClick);
        this.marker.addListener('mouseover', () => this.infoWindow.open(this.map, this.marker));
        this.marker.addListener('mouseout', () => this.infoWindow.close());
    }

    beforeUnmount() {
        this.marker.setMap(null);
        this.marker = null;
    }
}
